import React, { Component } from "react";
import { Box, Typography, IconButton, TextField } from "@material-ui/core";
import { PersonAdd, GroupAdd, AddCircle, Cancel } from "@material-ui/icons";
import { FirebaseContext } from "../../FirebaseInit";

class ChatListControls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newChat: false,
      newGroup: false,
      emailOrName: "",
      loading: false
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleNewChat = this.handleNewChat.bind(this);
    this.addNewChat = this.addNewChat.bind(this);
  }

  handleClick(e) {
    const name = e.currentTarget.name;
    if (name === "newChat") {
      if (this.state.newGroup === true) this.setState({ newGroup: false });
      this.setState({ newChat: !this.state.newChat });
    } else if (name === "newGroup") {
      if (this.state.newChat === true) this.setState({ newChat: false });
      this.setState({ newGroup: !this.state.newGroup });
    } else this.setState({ newChat: false, newGroup: false });
  }

  handleNewChat(e) {
    this.setState({ emailOrName: e.target.value });
  }

  addNewChat(firebase, e) {
    e.preventDefault();

    if (this.state.newChat) {
      if (this.state.emailOrName === this.props.user.email) {
        this.props.toggleAlert("You cannot chat with yourself !!!", "info");
        return;
      }

      if (
        this.props.chats.findIndex(
          obj => obj.email === this.state.emailOrName
        ) > -1
      ) {
        this.props.toggleAlert("Chat already exists", "warning");
        return;
      }
      this.setState({ loading: true });

      firebase
        .fs()
        .collection("users")
        .where("email", "==", this.state.emailOrName)
        .get()
        .then(user => {
          if (!user.empty) {
            const senderInfo = {
              [this.props.user.uid]: {
                email: this.props.user.email,
                uid: this.props.user.uid,
                username: this.props.user.displayName,
                ppURL: this.props.user.photoURL,
                lastmod: firebase.fs.Timestamp.now(),
                joined:firebase.fs.Timestamp.now(),
              }
            };

            const receiverInfo = {
              [user.docs[0].id]: {
                email: this.state.emailOrName,
                uid: user.docs[0].id,
                username: user.docs[0].data().username,
                ppURL: user.docs[0].data().ppURL,
                lastmod: firebase.fs.Timestamp.now(),
                joined:firebase.fs.Timestamp.now(),
              }
            };

            const order = user.docs[0].id < this.props.user.uid ? 0 : 1;

            const chatID = order
              ? `${user.docs[0].id}_${this.props.user.uid}`
              : `${this.props.user.uid}_${user.docs[0].id}`;

            const activeMembers = [this.props.user.email];

            const membersInfo =
              order === 0
                ? { ...receiverInfo, ...senderInfo }
                : { ...senderInfo, ...receiverInfo };

            firebase
              .fs()
              .collection("chats")
              .where("chatID", "==", chatID)
              .get()
              .then(doc => {
                if (!doc.empty) {
                  let order = this.props.user.uid < user.docs[0].id ? 0 : 1;
                  let status = order === 0 ? 'status1' : 'status2'
                  firebase
                    .fs()
                    .collection("chats")
                    .doc(chatID)
                    .set(
                      {
                        activeMembers: firebase.fs.FieldValue.arrayUnion(
                          this.props.user.email
                        ),
                        membersInfo: { ...senderInfo },
                        [status]:'Out'
                      },
                      { merge: true }
                    )
                    .then(() => {
                      this.props.toggleAlert("Contact added!", "success");
                    })
                    .catch(err =>
                      this.props.toggleAlert(
                        "Failed to add contact. Please try again.",
                        "error"
                      )
                    );
                  return;
                } else {
                  firebase
                    .fs()
                    .collection("chats")
                    .doc(chatID)
                    .set({
                      chatID: chatID,
                      activeMembers: activeMembers,
                      membersInfo: membersInfo,
                      unread: null,
                      count: 0,
                      status1: "Out",
                      status2: "Out",
                      lastmod: firebase.fs.Timestamp.now()
                    })
                    .then(() => {
                      this.props.toggleAlert("Contact added!", "success");
                    })
                    .catch(err =>
                      this.props.toggleAlert(
                        "Failed to add contact. Please try again.",
                        "error"
                      )
                    );
                }
              })
              .catch(err =>
                this.props.toggleAlert(
                  "Failed to add contact. Please try again.",
                  "error"
                )
              );

            this.setState({ newChat: false, emailOrName: "", loading: false });
          } else {
            this.setState({ loading: false });
            this.props.toggleAlert("User does not exist", "error");
          }
        })
        .catch(err => {
          this.props.toggleAlert(
            "Failed to add contact. Please try again.",
            "error"
          );
          this.setState({ newChat: false, emailOrName: "", loading: false });
        });
    } else if (this.state.newGroup) {
      
      if (this.props.groups.findIndex(item => {
        return (item.name === this.state.emailOrName && item.creator === this.props.user.email)
      }) > -1
      ) {
        this.props.toggleAlert(
          `A group with the name ${this.state.emailOrName} already exists`,
          "error"
        );
        return;
      }

      this.setState({ loading: true });

      firebase
        .fs()
        .collection("groups")
        .add({
          creator: this.props.user.email,
          name: this.state.emailOrName,
          members: [this.props.user.email],
          membersInfo: {
            [this.props.user.uid]: {
              admin: true,
              email: this.props.user.email,
              username: this.props.user.displayName,
              ppURL: this.props.user.photoURL,
              joined: firebase.fs.Timestamp.now()
            }
          },
          lastmod: firebase.fs.Timestamp.now(),
          unread: {
            [this.props.user.uid]: { count: 0, status: "Out" }
          }
        })
        .then(() => {
          this.props.toggleAlert("Created Group!", "success");
          this.setState({ newGroup: false, emailOrName: "", loading: false });
        })
        .catch(err => {
          this.props.toggleAlert(
            "Failed to create group. Please try again.",
            "error"
          );
          this.setState({ newChat: false, emailOrName: "", loading: false });
        });
    }
  }

  render() {
    const { newChat, newGroup, loading } = this.state;
    const firebase = this.context;
    return (
      <>
        <Box
          display="flex"
          p={2}
          alignItems="center"
          justifyContent="space-around"
        >
          <Typography color="inherit" variant="h5" component="h5">
            Chats
          </Typography>
          <Box width={1 / 3} display="flex" justifyContent="space-between">
            <IconButton
              name="newChat"
              onClick={this.handleClick}
              size="small"
              color="inherit"
            >
              <PersonAdd fontSize="large" />
            </IconButton>
            <IconButton
              name="newGroup"
              onClick={this.handleClick}
              size="small"
              color="inherit"
            >
              <GroupAdd fontSize="large" />
            </IconButton>
          </Box>
        </Box>

        {(newChat || newGroup) && (
          <Box p={1}>
            <form onSubmit={this.addNewChat.bind(this, firebase)}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                {newChat && (
                  <TextField
                    onChange={this.handleNewChat}
                    fullWidth
                    autoFocus
                    variant="filled"
                    label={"Enter an email"}
                    required
                    disabled={loading}
                  />
                )}
                {newGroup && (
                  <TextField
                    onChange={this.handleNewChat}
                    fullWidth
                    autoFocus
                    variant="filled"
                    label={"Enter group name"}
                    required
                    disabled={loading}
                  />
                )}

                <Box ml={1}>
                  <IconButton
                    disabled={loading}
                    color="primary"
                    type="submit"
                    size="small"
                  >
                    <AddCircle />
                  </IconButton>
                  <IconButton
                    name="cancel"
                    color="secondary"
                    onClick={this.handleClick}
                    size="small"
                  >
                    <Cancel />
                  </IconButton>
                </Box>
              </Box>
            </form>
          </Box>
        )}
      </>
    );
  }
}
ChatListControls.contextType = FirebaseContext;
export default ChatListControls;
